import React from 'react'
import Box from '../components/Box'

export default function Section15() {
    return (
        <div className="section">
            <h2>Section XV: Settings</h2>
            <p>Modify the following settings by tapping the “Settings” button on the bottom toolbar of the main screen. Settings are also available in the iOS Settings app.</p>
            <Box sectionData={'start'} title={'Appearance'} body={`Theme: 
        • Choose from several color schemes.`} />


            <Box title={'Record Configuration'} body={`Students: 
        • Sort (Last Name, First Name, Student ID). Selects the sort order for students across all views. 
        • Display  ([First,  Middle,  Last],[Last,  First,  Middle]).  Selected  the  display  order  for  student 
        names.  
        Assignments: 
        • Sort (Name, Date): Selects the sort order for assignments across all views. 
        • Descending Order (ON/OFF): Select whether assignments are sorted in ascending or 
        descending order. `} />


            <Box title={'Report Configuration'} body={`Class Reports: •Include  Notes    (ON/OFF).    If  selected,  reports  generated  in  the  class  report  generator  will 
        include notes.  
        • Teacher Emails: 
        o Individual  Reports:  Generate  and  email  a  separate  PDF  report  for  each  class  /  type 
        combination. 
        o Merged Reports: Merge multiple class report types into one file before emailing. 
        o Include Both: Include both individual and merged reports. 
        • Hide Student Names 
        o If enabled, class reports will include the student ID only. 
        • Include Class Average 
        o If enabled, reports include the average of all calculated grades for the class. 
        • Include Tardy in Attended 
        o If  enabled,  the  ‘%  Attended’  calculation  will  include  both  tardy  and  present  status.    If 
        disabled, only entries marked present will be included in the calculation. 
        • Display Decimals 
        o The number of decimal places to include on calculated values.
        Student Reports:
        • Include  Notes  (ON/OFF).  If  selected,  reports  generated  in  the  student  report  generator  will 
        include notes. 
        • Include  Photos    (ON/OFF).  If  selected,  reports  generated  in  the  student  report  generator  will 
        include student photos.  
        • Student Emails / Teacher Emails 
        o Individual Reports: Send a PDF file for each student and report type. 
        o Merged  Reports:  Merge  multiple  report  types  (attendance,  grades,  summary)  together 
        to generate a single PDF file per student.oInclude Both: Sends individual and merged files. 
        • Display Decimals 
        o The number of decimal places to include on calculated values.
        Assignment Reports:
        • Include  Notes  (ON/OFF).  If  selected,  reports  generated  in  the  student  report  generator  will 
        include notes.`} />
        
            <Box title={'View Configuration'} body={`Main View:
    • Hide Student Grades (ON/OFF): Choose to display or hide current student grade on the main
    view.
    • Show Attendance Status (ON/OFF): Choose to display or hide the current attendance status
    on the main and grade entry view. This feature works by finding an attendance record with the
    current date and displaying a red, green, or yellow dot next to the student name to indicate
    status.
    o Red: Absent (Excused or Unexcused)
    o Yellow: Tardy (Excused or Unexcused)
    o Green: Present
    o Blank: No record present or student status not indicated.
    • Hide Dropped Students (ON/OFF): If enabled, removes dropped students from the main view.
    • Display Class Average (ON/OFF): If enabled the class average grade is displayed under the
    class roster on the main view.
    • Display Decimals
    o The number of decimal places to include on calculated values.
    Class List:
    • Count Active (ON/OFF): If enabled, the student count in the class list will exclude dropped
    students. There is a performance hit at app startup if this option is enabled.
    Score Entry:
    • Status Date Source (Today, Assignment Date): Select whether the attendance status indicator
    on the grade entry view uses attendance status for the current date or for the date entered for
    the assignment.
    • Display Decimals
    o The number of decimal places to include on calculated values.
    Behavior Entry:
    • Labels 1 – 4: Custom labels for the four available behavior marks.
    • Reset on Launch: Will reset the behavior marks to default on the next launch of GradeBook
    Pro.`} />

            <Box sectionData={'end'} title={'Diagnostics'} body={`Diagnostics:
    • Version: The currently installed version of the app.
    • Acknowledgements: License information for third party libraries used in GradeBook Pro.`} />
        </div>
    )
}
